import React from "react";

/**
 * XPEN-3206: one place deciding how a GL account class reads, so the workflow
 * picker, the rule summary card and the Admin GL column cannot drift apart.
 *
 * 3E gives each class a per-firm code and a description. The code is what the
 * rule stores and what the firm's chart of accounts is keyed on, so it leads;
 * the description follows for anyone who does not know the codes by heart.
 */
export const glAccountClassLabel = (code, description) => {
    const classCode = String(code ?? "").trim();
    const classDescription = String(description ?? "").trim();
    if (!classCode) return classDescription;
    // Plenty of firms name a class after its code (BCF has Cash / Cash),
    // and "Cash - Cash" reads as a mistake.
    return classDescription && classDescription !== classCode
        ? `${classCode} - ${classDescription}`
        : classCode;
};

/**
 * The same thing rendered, with the code picked out. Use wherever the surface can
 * take a node; `glAccountClassLabel` stays the plain-text form, for a select's
 * search text, an attribute, or a test.
 */
export const glAccountClassNode = (code, description) => {
    const text = glAccountClassLabel(code, description);
    const classCode = String(code ?? "").trim();
    if (!text) return "";
    if (!classCode || text === classCode) return <strong>{text}</strong>;
    return <>
        <strong>{classCode}</strong>{text.slice(classCode.length)}
    </>;
};

export default glAccountClassLabel;
